module.exports = __webpack_public_path__ + "static/media/shape1.pngfeat0.651311bb.png";